/**
 * 扩位简称
 */

 import React, { useEffect, useState } from "react"
import { quote_item_name, single_quote } from '../index'
import { PopMask } from "../../layer"
import './index.less'
import ReactDOM from "react-dom"

export function ExpandName(props:{detail_data: any}){

  let text = single_quote[quote_item_name.长名称](props.detail_data).source
  
  if(text != '' && text != "-" &&  text != undefined){
    return <ExpandFullName name={text}/>
  }
  return <></>
}

function ExpandFullName(props:{name:string}){
  const [expandNameVisible,setExpandNameVisible] = useState(false)

  const clickIcon = ()=>{
    setExpandNameVisible(true)
  }

  return (
    <>
      <span ><i className='expand-full-title' onClick={clickIcon}></i></span>
      {expandNameVisible && (
        <>
          <PopMask onClose={() => setExpandNameVisible(false)} />
          <FullNamePanel name={props.name} onClose={() => setExpandNameVisible(false)} />
        </>
      )}
    </>
  )
}

export function FullNamePanel(props:{name:string,onClose:Function}) {

  const close = ()=>{
    props.onClose()
  }

  return ReactDOM.createPortal(
    <div className="expand-pop">
      <div>
        <p className="expand-title">扩位简称</p>
        <p className="expand-name">{props.name}</p>
      </div>
      <div>
        <a className="expand-confirm" href="#" onClick={(e)=>{e.preventDefault();close()}}>
          确定
        </a>
      </div>
    </div>,document.body
  )
}